<template>
  <div id="profile-page4">
    <!-- Profile Header Banner -->
    <div class="profile-header-banner">
      <div class="banner-overlay"></div>
      <v-container>
        <div class="banner-content">
          <v-icon class="banner-icon">mdi-account-circle</v-icon>
          <h1 class="banner-title">Your Profile</h1>
          <p class="banner-subtitle">Complete your information and details</p>
        </div>
      </v-container>
    </div>

    <!-- Main Content Area -->
    <v-container fluid class="profile-container">
      <!-- Personal Information - Full Width -->
      <v-row class="mb-4">
        <v-col cols="12">
          <div class="section-fade-in">
            <personal-information />
          </div>
        </v-col>
      </v-row>

      <!-- Contact & Identity Section -->
      <div class="section-header">
        <v-icon class="section-icon" color="primary">mdi-account</v-icon>
        <h2 class="section-title">Contact & Identity Information</h2>
        <div class="section-divider"></div>
      </div>
      <v-row class="mb-6">
        <v-col cols="12" md="6" lg="4">
          <div class="card-fade-in" style="animation-delay: 0.1s">
            <communication-details />
          </div>
        </v-col>
        <v-col cols="12" md="6" lg="4" v-if="rows.AadharCardFlag">
          <div class="card-fade-in" style="animation-delay: 0.2s">
            <aadhar-details />
          </div>
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <div class="card-fade-in" style="animation-delay: 0.3s">
            <address-information />
          </div>
        </v-col>
      </v-row>

      <!-- Professional & Career Section -->
      <div class="section-header">
        <v-icon class="section-icon" color="success">mdi-briefcase</v-icon>
        <h2 class="section-title">Professional Details</h2>
        <div class="section-divider"></div>
      </div>
      <v-row class="mb-6">
        <v-col cols="12" md="6" lg="4">
          <div class="card-fade-in" style="animation-delay: 0.1s">
            <profession-details />
          </div>
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <div class="card-fade-in" style="animation-delay: 0.2s">
            <training-career />
          </div>
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <div class="card-fade-in" style="animation-delay: 0.3s">
            <nominee-details />
          </div>
        </v-col>
      </v-row>

      <!-- Documents & Verification Section -->
      <div class="section-header">
        <v-icon class="section-icon" color="warning">mdi-file-document</v-icon>
        <h2 class="section-title">Documents & Verification</h2>
        <div class="section-divider"></div>
      </div>
      <v-row class="mb-6">
        <v-col cols="12" md="6" lg="4">
          <div class="card-fade-in" style="animation-delay: 0.1s">
            <document-details />
          </div>
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <div class="card-fade-in" style="animation-delay: 0.2s">
            <view-details />
          </div>
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <div class="card-fade-in" style="animation-delay: 0.3s">
            <social-media />
          </div>
        </v-col>
      </v-row>

      <!-- Additional Information Section -->
      <div class="section-header">
        <v-icon class="section-icon" color="info">mdi-information</v-icon>
        <h2 class="section-title">Additional Information</h2>
        <div class="section-divider"></div>
      </div>
      <v-row class="mb-6">
        <v-col cols="12" md="6" lg="4">
          <div class="card-fade-in" style="animation-delay: 0.1s">
            <family-details />
          </div>
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <div class="card-fade-in" style="animation-delay: 0.2s">
            <blood-donation-details />
          </div>
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <div class="card-fade-in" style="animation-delay: 0.3s">
            <foundation-contribution />
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import PersonalInformation from "@/view/pages/profile/profile-cards-1/PersonalInformation";
import TrainingCareer from "@/view/pages/profile/profile-cards-1/TrainingCareer";
import DocumentDetails from "@/view/pages/profile/profile-cards-1/DocumentDetails";
import ProfessionDetails from "@/view/pages/profile/profile-cards-1/ProfessionDetails";
import BloodDonationDetails from "@/view/pages/profile/profile-cards-1/BloodDonationDetails";
import FoundationContribution from "@/view/pages/profile/profile-cards-1/FoundationContribution";
import ViewDetails from "@/view/pages/profile/profile-cards-1/ViewDetails";
import NomineeDetails from "@/view/pages/profile/profile-cards-1/NomineeDetails";
import SocialMedia from "@/view/pages/profile/profile-cards-1/SocialMedia";
import CommunicationDetails from "@/view/pages/profile/profile-cards-1/CommunicationDetails";
import AddressInformation from "@/view/pages/profile/profile-cards-1/AddressInformation";
import FamilyDetails from "@/view/pages/profile/profile-cards-1/FamilyDetails";
import AadharDetails from "@/view/pages/profile/profile-cards-1/AadharDetails";

export default {
  name: "custom-page",
  components: {
    PersonalInformation,
    TrainingCareer,
    DocumentDetails,
    ProfessionDetails,
    BloodDonationDetails,
    FoundationContribution,
    ViewDetails,
    NomineeDetails,
    SocialMedia,
    CommunicationDetails,
    AddressInformation,
    FamilyDetails,
    AadharDetails,
  },
  computed: {
    ...mapGetters(["currentUserPhoto"]),
  },
  data() {
    return {
      ProgessStart: 0,
      uploadPercentage: 0,

      SuccessMessageTxtFlag: 0,
      SuccessMessageTxt: "",

      ErrorMessageTxtFlag: 0,
      ErrorMessageTxt: "",

      totalActiveAwards: 0,
      totalPendingAwards: 0,

      ResultFlag: 0,

      tab: null,
      MemberId: "",
      address: {},
      contact: [],
      designation: [],
      dues: [],

      rows: {},
      RoleId: "",
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Profile 3" }]);
  },
  watch: {
    rows: function () {
      console.log("watch rows");
      var rows = this.rows;
      var n1 = Object.keys(rows).length;
      console.log("n1=" + n1 + ", rows=" + JSON.stringify(rows));
      if (n1 > 0) {
        this.ResultFlag = 1;
        this.address = rows.Address[0];
        this.contact = rows.Contact;
        this.designation = rows.OfficesHeld;
        this.dues = rows.Dues;
      }
    },
  },
  methods: {
    backPage() {
      this.$router.go(-1);
    },
    resetMessageTxt() {
      console.log("resetMessageTxt called");
      this.ErrorMessageTxt = 0;
      this.ErrorMessageTxtFlag = "";
      this.SuccessMessageTxtFlag = 0;
      this.SuccessMessageTxt = "";
      this.totalActiveAwards = 0;
      this.totalPendingAwards = 0;
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.getTableRecords();
    },
    getTableRecords() {
      console.log("getTableRecords called");

      this.resetMessageTxt();

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/members/show";
      var upload = {
        UserInterface: 2,
        MemberId: this.MemberId,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var records = "";
      var flag = 0;

      // thisIns.pageLoadingOn()
      thisIns.ProgessStart = 1;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          // thisIns.pageLoadingOff()
          thisIns.ProgessStart = 0;

          output = response.data.output;
          flag = response.data.flag;
          records = response.data.records[0];
          console.log("output=" + output + ", flag=" + flag);

          if (flag == 1) {
            thisIns.rows = records;
          } else {
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
        });
    },
  },
  beforeMount() {
    console.log(this.$route.query.id);
    this.MemberId = this.$route.query.id;

    var token = this.$session.get("token");
    token = token == (null || undefined) ? 0 : token;

    var RoleId = this.$session.get("RoleId");
    RoleId = RoleId == (null || undefined) ? 0 : RoleId;

    console.log("token=" + token + ", RoleId=" + RoleId);
    this.RoleId = RoleId;
    this.refreshPageData();
    // this.$router.push("/access-denied");
  },
};
</script>


<style lang="scss">
#profile-page4 {
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
  min-height: 100vh;
  padding-bottom: 40px;

  /* Profile Header Banner */
  .profile-header-banner {
    position: relative;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 24px 0 32px 0;
    margin-bottom: -16px;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url('data:image/svg+xml,<svg width="100" height="100" xmlns="http://www.w3.org/2000/svg"><defs><pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse"><path d="M 40 0 L 0 0 0 40" fill="none" stroke="rgba(255,255,255,0.1)" stroke-width="1"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
      opacity: 0.3;
    }

    .banner-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.1);
    }

    .banner-content {
      position: relative;
      text-align: center;
      color: white;
      z-index: 1;

      .banner-icon {
        font-size: 40px;
        margin-bottom: 8px;
        opacity: 0.9;
        animation: float 3s ease-in-out infinite;
      }

      .banner-title {
        font-size: 28px;
        font-weight: 700;
        margin-bottom: 4px;
        text-shadow: 2px 4px 8px rgba(0, 0, 0, 0.2);
        letter-spacing: 0.5px;
      }

      .banner-subtitle {
        font-size: 14px;
        opacity: 0.95;
        font-weight: 300;
        letter-spacing: 0.3px;
      }
    }
  }

  /* Profile Container */
  .profile-container {
    max-width: 1400px;
    margin: 0 auto;
    padding-top: 20px;
  }

  /* Section Headers */
  .section-header {
    display: flex;
    align-items: center;
    margin: 40px 0 24px 0;
    position: relative;

    .section-icon {
      font-size: 32px;
      margin-right: 12px;
      background: white;
      padding: 12px;
      border-radius: 12px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    .section-title {
      font-size: 24px;
      font-weight: 600;
      color: #2d3748;
      margin: 0;
      letter-spacing: 0.5px;
    }

    .section-divider {
      flex: 1;
      height: 2px;
      background: linear-gradient(to right, rgba(102, 126, 234, 0.4), transparent);
      margin-left: 20px;
    }
  }

  /* Animation Keyframes */
  @keyframes float {
    0%, 100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-10px);
    }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* Card Animations */
  .section-fade-in {
    animation: fadeInUp 0.6s ease-out;
  }

  .card-fade-in {
    animation: fadeInUp 0.6s ease-out;
    animation-fill-mode: both;
  }

  /* Enhanced Card Styles */
  .rounded-card {
    border-radius: 24px;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 28px rgba(0, 0, 0, 0.15) !important;
    }
  }

  #v-card {
    background: white;
    border-radius: 20px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
    border: 1px solid rgba(0, 0, 0, 0.05);

    &:hover {
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
      transform: translateY(-2px);
    }
  }

  /* Typography */
  #heading {
    font-size: 18px;
    font-weight: 600;
    font-family: "Poppins", sans-serif;
    color: #2d3748;
    letter-spacing: 0.3px;
  }

  #card-text {
    font-family: "Merriweather", serif;
    color: #4a5568;
    line-height: 1.6;
  }

  /* Icons */
  #app-bar-icon {
    margin-left: 0;
    color: #667eea;
    font-size: 22px;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.1);
    }
  }

  #edit-icon {
    font-size: 20px;
    color: #ed8936;
    transition: all 0.3s ease;

    &:hover {
      transform: rotate(90deg);
    }
  }

  /* Buttons */
  #view-button {
    color: white;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    font-family: "Poppins", sans-serif;
    font-size: 11px;
    font-weight: 600;
    border-radius: 8px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
      transform: translateY(-2px);
    }
  }

  #edit-button {
    color: white;
    background: linear-gradient(135deg, #f6ad55 0%, #ed8936 100%);
    font-family: "Poppins", sans-serif;
    font-size: 11px;
    font-weight: 600;
    border-radius: 8px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    box-shadow: 0 4px 12px rgba(237, 137, 54, 0.3);
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 6px 16px rgba(237, 137, 54, 0.4);
      transform: translateY(-2px);
    }
  }

  #add-button {
    color: white;
    background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(72, 187, 120, 0.3);
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 6px 16px rgba(72, 187, 120, 0.4);
      transform: translateY(-2px);
    }
  }

  /* Tabs */
  .v-tab {
    font-size: 14px;
    font-weight: 500;
    text-transform: none;
    letter-spacing: 0.3px;
    transition: all 0.3s ease;

    &:hover {
      color: #667eea;
    }
  }

  /* App Bar */
  .v-app-bar {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  /* Expansion Panels */
  .v-expansion-panel-header {
    height: 48px;
    font-weight: 500;
    transition: all 0.3s ease;

    &:hover {
      background-color: rgba(102, 126, 234, 0.05);
    }
  }

  .v-expansion-panel {
    border-radius: 12px !important;
    margin-bottom: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    overflow: hidden;

    &::before {
      box-shadow: none;
    }
  }

  /* Responsive Design */
  @media (max-width: 960px) {
    .profile-header-banner {
      padding: 20px 0 28px 0;

      .banner-content {
        .banner-icon {
          font-size: 36px;
        }

        .banner-title {
          font-size: 24px;
        }

        .banner-subtitle {
          font-size: 13px;
        }
      }
    }

    .section-header {
      margin: 30px 0 20px 0;

      .section-title {
        font-size: 20px;
      }

      .section-icon {
        font-size: 28px;
        padding: 10px;
      }
    }
  }

  @media (max-width: 600px) {
    .profile-header-banner {
      padding: 16px 0 24px 0;
      margin-bottom: -12px;

      .banner-content {
        .banner-icon {
          font-size: 32px;
          margin-bottom: 6px;
        }

        .banner-title {
          font-size: 22px;
        }

        .banner-subtitle {
          font-size: 12px;
        }
      }
    }

    .section-header {
      flex-wrap: wrap;
      margin: 24px 0 16px 0;

      .section-divider {
        display: none;
      }

      .section-title {
        font-size: 18px;
      }
    }
  }

  /* Scrollbar Styling */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 10px;

    &:hover {
      background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
    }
  }
}
</style>